<div #dialogRoot cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>Include Builder</h2>

<mat-dialog-content style="overflow-y: hidden; height: 300px; width: 450px;">
    <div style="margin-top: 10px; width: 100%; max-height: 200px; display: flex;">
        <div class="list-panel">
            <h3 style="color: #d36b0b;">Available Columns</h3>
            <mat-selection-list #list [multiple]="false"
                style="background-color: #161616; overflow-y: auto; height: 100%;">
                <mat-list-option *ngFor="let field of fields" [value]="field">{{field}}</mat-list-option>
            </mat-selection-list>

        </div>
        <div style="margin-top: 50px; flex: 0;">
            <button mat-icon-button color="primary" (click)="newItem(list.selectedOptions.selected[0]?.value)">
                <mat-icon class="material-icons">keyboard_double_arrow_right</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="removeItem(includeList.selectedOptions.selected[0]?.value)">
                <mat-icon class="material-icons">keyboard_double_arrow_left</mat-icon>
            </button>
        </div>
        <div class="list-panel">
            <h3 style="color: #d36b0b;">Included Columns</h3>
            <div style="height: 100%; display: flex; flex-direction: column;">
                <mat-selection-list style="flex: 1; background-color: #161616; overflow-y: auto; height: 100%" #includeList
                    [multiple]="false" (selectionChange)="includeInfoSelected($event)">
                    <mat-list-option *ngFor="let includeInfo of includeItems" [value]="includeInfo">{{includeInfo.includeField}}
                    </mat-list-option>
                </mat-selection-list>

            </div>

        </div>

    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="saveChanges()" tabindex="1">SAVE</button>
    <button style="margin-left: 10px" mat-raised-button [mat-dialog-close]="false" tabindex="-1">CANCEL</button>
</mat-dialog-actions>
</div>